"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorityLevel = void 0;
var AuthorityLevel;
(function (AuthorityLevel) {
    /**
     * 비로그인 상태에서 호출
     */
    AuthorityLevel["UNKNOWN"] = "UNKNOWN";
    /**
     * 웹, 앱에서 회원이 호출
     */
    AuthorityLevel["USER"] = "USER";
    /**
     * 호스트 어드민 툴에서 호스트 권한을 가지고 있는 사용자가 호출
     */
    AuthorityLevel["HOST"] = "HOST";
    /**
     * 어드민 툴에서 어드민 권한을 가지고 있는 사용자가 호출
     */
    AuthorityLevel["ADMIN"] = "ADMIN";
    /**
     * 시스템에 의해 호출: 스케즐러, 워커에 의해 구동되는 경우 또는 비로그인 상태에서 실행하는 경우(얘: 회원가입)
     */
    AuthorityLevel["SYSTEM"] = "SYSTEM";
})(AuthorityLevel = exports.AuthorityLevel || (exports.AuthorityLevel = {}));
